import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, StarIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
const FinalCTA = () => {
  const {
    t,
    language
  } = useLanguage();
  return <section className="py-20 px-4 bg-primary text-white relative overflow-hidden" data-id="element-178" data-mp="3rsle866cse4o">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-179" data-mp="3dsu5ajup1nxj"></div>
      <div className="absolute -top-24 -right-24 w-64 h-64 bg-accent rounded-full blur-3xl opacity-20" data-id="element-180" data-mp="3hw09zn25r71w"></div>
      <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-success rounded-full blur-3xl opacity-20" data-id="element-181" data-mp="33x0mwjuan07u"></div>

      <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-182" data-mp="123jfnha2s1dm">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-2 rounded-full border border-white/20 mb-8" data-id="element-183" data-mp="121gfi4f7krv6">
          <div className="flex" data-id="element-184" data-mp="q8deqrs1cmpl">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#FFD700] fill-[#FFD700]" data-id="element-185" data-mp="q6aktwnri9fl" data-mpi={i} />)}
          </div>
          <span className="text-sm font-medium text-gray-200" data-id="element-186" data-mp="yznlxlvzchcr">
            {t.finalCta.badge}
          </span>
        </div>

        <h2 className="font-heading font-extrabold text-4xl md:text-6xl mb-6 leading-tight" data-id="element-187" data-mp="v1gclc3uiibl">
          <span className="text-accent block text-2xl md:text-3xl mb-2 uppercase tracking-widest opacity-90" data-id="element-188" data-mp="7bvh5tqi9slf">
            {t.finalCta.headlineAccent}
          </span>
          {t.finalCta.headline}
        </h2>

        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-189" data-mp="g833vdth3rdl">
          {t.finalCta.subheadline}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-190" data-mp="1rpck7rhb23ao">
          <Button href="#lead-form" variant="success" size="lg" className="shadow-[0_4px_24px_rgba(37,211,102,0.35)] hover:shadow-[0_6px_32px_rgba(37,211,102,0.5)] hover:scale-[1.03] text-lg px-10 py-4 font-bold" onClick={() => trackContact({
          location: 'final_cta',
          language,
          action: 'scroll_to_form'
        })} data-id="element-191" data-mp="1mqjiewbds0qc">
            <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-192" data-mp="yccycj538494" />
            {t.finalCta.cta}
          </Button>
        </div>

        <p className="mt-6 text-sm text-gray-400" data-id="element-193" data-mp="1kj59bhkvfmz">{t.finalCta.footer}</p>
      </div>
    </section>;
};
export default FinalCTA;